import React from "react";
import contactImage from "../assets/ght-contact.png";
const Contact = () => {
  return (
    <>
      <section className="container-fluid container--contact">
        <div className="section-width">
          <div className="section-title-wrapper ">
            <h5 className="section-title text-center">
              Contact Us
            </h5>
          </div>
          <div className="card card--contact p-0">
            <div className="card--contact__content">
              <div className="col-md-6">
                <img
                  src={contactImage}
                  className="img-fluid contact-banner-image"
                  alt="gayatri-home-tuition-contact-image"
                />
              </div>
              <div className="col-md-6">
                <p className="card-text contact-tagline-text">
                  Ready to unlock your child’s full potential? Join Gayatri Home
                  Tuition today and watch their confidence—and grades—soar! 🚀📚
                  Call now to book your free trial lesson. <strong>Limited slots
                  available</strong>
                </p>
                <p className="text-contact-number">+91 6280017422</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Contact;
